export { default } from './es/icons/InfoOutlined';